import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";

export default function KeyContactCards({
  customClass = "",
  card1Items = [],
  logo1,
  logo2,
}) {
  return (
    <section id='KeyContacts' className={`${styles.root} ${customClass}`}>
      <Container>
        <Row className="align-items-stretch">

          <h1 className="mt-4 mb-4">Key contacts</h1>

          {/* Left — stacked inner cards */}
          <Col xl={4} sm={12} className="d-flex">
            <div className="feature-card feature-card--1 w-100 d-flex flex-column">
              {card1Items.map((item, index) => (
                <div key={index} className="feature-card-content feature-card-content--square flex-grow-1">
                  {item.logo && (
                    <div className="feature-inner-logo">
                      <img src={item.logo} alt="" width={140} height={140} />
                    </div>
                  )}
                  {item.title && <h5 className="text-center">{item.title}</h5>}
                  {item.bulletPoints && (
                    <ul className="list-unstyled">
                      {item.bulletPoints.map((point, i) => (
                        <li key={i}>
                          {point.label || point}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </Col>

          {/* Middle */}
          <Col xl={4} sm={12} className="d-flex flex-column">
            <div className="feature-logo">
              <img src={logo1} alt="logo1" />
            </div>
            <div className="feature-card feature-card--2 mt-3 flex-grow-1">
              <div className="feature-card-content feature-card-content--left">
                <h5>ICE - in case of emergency</h5>
                <p>Save an ICE contact on your phone so the right person can be contacted if something happens to you.</p>
                <h5>How to set it up</h5>
                <ul>
                  <li>iPhone: Health app → Medical ID → add emergency contact</li>
                  <li>Android: Settings → Safety & emergency → add emergency contact</li>
                </ul>
                <h6>Please keep your ICE contact up to date.</h6>
                <p>This information can be seen by emergency services from your lock screen.</p>
              </div>
            </div>
          </Col>

          {/* Right */}
          <Col xl={4} sm={12} className="d-flex flex-column justify-content-between">
            <div className="feature-card feature-card--3">
              <div className="feature-card-content feature-card-content--left feature-card-content--compact">
                <h5>Emergency</h5>
                <ul>
                  <li>Police, Fire, Ambulance - <strong>999/112</strong></li>
                  <li>If you can't speak: Call 999 and <strong>press 55</strong></li>
                  <li>Non-emergency police - <strong>101</strong></li>
                </ul>
              </div>
            </div>
            <div className="feature-logo">
              <img src={logo2} alt="logo2" />
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
}